import validate from "/codebuild/output/src1120545451/src/consort-headless/nuxtapp/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirects_45global from "/codebuild/output/src1120545451/src/consort-headless/nuxtapp/middleware/redirects.global.js";
import manifest_45route_45rule from "/codebuild/output/src1120545451/src/consort-headless/nuxtapp/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirects_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}